import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class NavigateMigrationsTool implements IManagementTool {
  private _router = inject(Router);

  readonly name = 'navigate-migrations';
  readonly label = 'Migrations';
  readonly icon = 'integration_instructions';
  readonly description = 'Navigate to the migrations management page';

  async run(_context: IToolRunContext): Promise<void> {
    await this._router.navigate(['/management/migrations']);
  }
}
